import React from "react";
import { Center } from "@chakra-ui/react";

import AuthLayout from "../../layouts/AuthLayout";
import { ResetPasswordForm } from "../../components/ResetPasswordForm";

export default function ResetPassword() {
  return (
    <AuthLayout>
      <Center flex="1">
        <ResetPasswordForm
          px={{ base: "4", md: "8" }}
          py={{ base: "12", md: "48" }}
          width="full"
          maxW="md"
        />
      </Center>
    </AuthLayout>
  );
}
